import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { thClass, tdClass, euro } from './adminUi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminCustomers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/clients`)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : r.data.clients || []))
      .catch(() => toast.error('Échec du chargement des clients'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-customers">
      <h2 className="font-heading text-2xl mb-6">Clients ({items.length})</h2>
      {loading ? (
        <p className="text-foreground/40">Chargement…</p>
      ) : items.length === 0 ? (
        <p className="text-foreground/40 py-8">Aucun client.</p>
      ) : (
        <div className="overflow-x-auto border border-black/10">
          <table className="w-full">
            <thead>
              <tr>
                <th className={thClass}>Nom</th>
                <th className={thClass}>Email</th>
                <th className={thClass}>Commandes</th>
                <th className={thClass}>Total dépensé</th>
                <th className={thClass}>Inscrit le</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id}>
                  <td className={tdClass}>{[c.first_name, c.last_name].filter(Boolean).join(' ') || '—'}{c.role === 'admin' && <span className="text-gold text-xs ml-2">admin</span>}</td>
                  <td className={tdClass}>{c.email}</td>
                  <td className={tdClass}>{c.orders_count ?? 0}</td>
                  <td className={tdClass}>{euro(c.total_spent)}</td>
                  <td className={tdClass}>{(c.created_at || '').slice(0, 10) || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminCustomers;
